import React from 'react'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { GolferShortName } from '@app/evaluation-core/types'
import { setSelectedHole } from '@app/evaluation-core/actions/evaluationActions'
import { useDispatch } from 'react-redux'
import useEvaluation from '@common/hooks/useEvaluation'
import useEvaluationUser from '@common/hooks/useEvaluationUser'
import { NavButton, NavLabel } from './GolferNavigator.styles'

export interface GolferNavigatorProps {
  onPrev?: () => void
  onNext?: () => void
}

export const GolferNavigator: React.FC<GolferNavigatorProps> = ({
  onPrev,
  onNext,
}) => {
  const dispatch = useDispatch<any>()
  const { evaluation } = useEvaluation()
  const { view } = useEvaluationUser()

  if (!evaluation || !view) return null

  const tee = evaluation.holes[view.hole]?.tees[view.tee]
  if (!tee) return null

  const availableGolfers = tee.golfers
  const currentGolfer = view.golfer

  const currentIndex = availableGolfers.indexOf(currentGolfer)
  if (currentIndex === -1) return null

  const prevGolfer = availableGolfers[currentIndex - 1]
  const nextGolfer = availableGolfers[currentIndex + 1]

  const hasPrev = prevGolfer !== undefined
  const hasNext = nextGolfer !== undefined

  const handlePrev = () => {
    if (hasPrev) {
      if (onPrev) {
        onPrev()
      } else {
        dispatch(
          setSelectedHole(view.hole, view.tee, prevGolfer, view.adjustment)
        )
      }
    }
  }

  const handleNext = () => {
    if (hasNext) {
      if (onNext) {
        onNext()
      } else {
        dispatch(
          setSelectedHole(view.hole, view.tee, nextGolfer, view.adjustment)
        )
      }
    }
  }

  const getGolferLabel = (golfer: GolferShortName | undefined): string => {
    if (!golfer) return ''
    switch (golfer) {
      case GolferShortName.ScratchMen:
        return 'SM'
      case GolferShortName.ScratchWomen:
        return 'SW'
      case GolferShortName.BogeyMen:
        return 'BM'
      case GolferShortName.BogeyWomen:
        return 'BW'
      default:
        return ''
    }
  }

  return (
    <>
      <NavButton
        onClick={handlePrev}
        disabled={!hasPrev}
        data-testid="golfer-nav-prev"
      >
        <NavLabel disabled={!hasPrev}>{getGolferLabel(prevGolfer)}</NavLabel>
        <FaChevronLeft size={16} />
      </NavButton>

      <NavButton
        onClick={handleNext}
        disabled={!hasNext}
        data-testid="golfer-nav-next"
      >
        <FaChevronRight size={16} />
        <NavLabel disabled={!hasNext}>{getGolferLabel(nextGolfer)}</NavLabel>
      </NavButton>
    </>
  )
}

export default GolferNavigator
